var React = require('react');

function IconDeliverValue (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"1","y":"1","width":"30","height":"30","rx":"2","stroke":"#00D664","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M22.6662 10.6666L13.6588 21.0963L9.77734 17.7777","stroke":"#DDDDDD","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

IconDeliverValue.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = IconDeliverValue;

IconDeliverValue.default = IconDeliverValue;
